/* Deferred curated/Jeremias alternatives. Automatic recommendations keep Dawn's
   existing component. Card custom elements and Shopify events connect on insert. */
if (!customElements.get('oe-related-products')) {
  customElements.define('oe-related-products', class extends HTMLElement {
    connectedCallback() {
      if (this.started || this.onPageLoad) return;
      this.onPageLoad = () => this.load();
      if (document.readyState === 'complete') this.load();
      else window.addEventListener('load', this.onPageLoad, { once: true });
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.onPageLoad);
      this.onPageLoad = null;
      this.controller?.abort();
      clearTimeout(this.timeout);
    }

    async load() {
      if (this.started || !this.isConnected) return;
      this.started = true;
      this.dataset.state = 'loading';
      this.hidden = false;
      this.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      this.timeout = setTimeout(() => this.controller.abort(), 15000);
      try {
        // Keep the current locale, market, variant and theme-preview context.
        const url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', this.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
        if (!response.ok) throw new Error(`Related section HTTP ${response.status}`);
        const sections = await response.json();
        const sectionHtml = sections?.[this.dataset.sectionId];
        if (typeof sectionHtml !== 'string') throw new Error('Missing related section response');
        const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const section = html.getElementById(`shopify-section-${this.dataset.sectionId}`);
        const content = section?.querySelector('[data-related-content]');
        if (!content || section.querySelector('oe-related-products')) throw new Error('Missing related section');
        if (!this.isConnected) return;
        if (!content.querySelector('.grid__item, product-recommendations')) {
          // Empty, deleted or unavailable references must leave no empty heading.
          this.dataset.state = 'empty';
          this.hidden = true;
          this.replaceChildren();
          return;
        }
        this.replaceChildren(content);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(this);
        this.dataset.state = 'ready';
      } catch {
        // A secondary recommendation failure must never affect the main product.
        this.dataset.state = 'error';
        this.hidden = true;
        this.replaceChildren();
      } finally {
        clearTimeout(this.timeout);
        this.removeAttribute('aria-busy');
      }
    }
  });
}
